import React, { useRef, useState } from "react";
import {
  ButtonGroup,
  Offcanvas,
  OffcanvasBody,
  UncontrolledTooltip,
} from "reactstrap";
import { toast } from "react-toastify";

import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import { Formik } from "formik";
import moment from "moment";
import Calendar from "assets/icon/calendar-pms.svg";
import { useNavigate } from "react-router-dom";
// import patientsScanImage from "assets/images/patients-scan.svg";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import plusIcon from "assets/icon/plus-rx.svg";
import ReactStrapTable from "components/reactStrapTable";
import exportIcon from "assets/icon/export-icon.svg";
import ExpandIcon from "assets/icon/expand-btn.svg";
import editIcon from "assets/icon/edit-black-icon.svg";
import dataRefreshIcon from "assets/icon/data-refresh.svg";
import dataSavaIcon from "assets/icon/data-save.svg";
import CloseIcon from "assets/icon/chatClose.svg";
import MinimizeIcon from "assets/icon/minimize-icon.svg";
import leftArrow from "assets/icon/left-arrow.svg";
import RefreshWhiteIcon from "assets/icon/refresh-white.svg";
import RefreshPrupleIcon from "assets/icon/refresh-purple.svg";
import searchWhiteIcon from "assets/icon/search-white.svg";
import searchInactiveIcon from "assets/icon/search-inactive.svg";
import RefreshPurpleIcon from "assets/icon/refresh-purple.svg";
import statusPurple from "assets/icon/status-save-icon.svg";
import saveWhiteIcon from "assets/icon/save-white-icon.svg";
import saveDisableIcon from "assets/icon/save-btn-icon-white.svg";
import calenderBlackIcon from "assets/inventory/calender-black-icon.svg";
import Select from "react-select";
import AddNewPatientDetails from "./PatientsPage/AddNewPatientDetails";
import MedicationHistory from "./PatientsPage/Medication/MedicationHistory";
import PatientEditInfo from "./PatientsPage/BasicInfo/PatientEditInfo";
import MedicationEditDetails from "./PatientsPage/Medication/MedicationEditDetails";

const PatientsPage = () => {
  const navigate = useNavigate();
  const [focusedInput, setFocusedInput] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartdate] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [todosOne, setTodosOne] = useState([]);
  const [selectedPatientIndex, setSelectedPatientIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandScreen, setExpandScreen] = useState(false);
  const [openMedicationDetails, setOpenMedicationDetails] = useState(false);
  const [openMedicationHistory, setOpenMedicationHistory] = useState(false);
  const [patientEdit, setPatientEdit] = useState(false);
  const bottomRef = useRef();
  const [rSelected, setRSelected] = useState("off");
  const [createNewPatient, setCreateNewPatient] = useState(false);
  const [dob, setDob] = useState("");

  const [selectedOptions, setSelectedOptions] = useState({
    option1: "",
    option2: "",
  });

  const [data, setData] = useState({
    lastname: "",
    firstname: "",
    phonenumber: "",
    dob: "",
    city: "",
    state: "",
    zipcode: "",
  });

  const [addData, setAddData] = useState([
    {
      id: 12,
      firstname: "John",
      lastname: "Doe",
      dob: "01/01/1985",
      phonenumber: "(555) 987-0001",
      streetaddress1: "101 Main St, Springfield, IL 62701",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 13,
      firstname: "Johnathan",
      lastname: "Doeman",
      dob: "04/12/1990",
      phonenumber: "(555) 987-0002",
      streetaddress1: "202 Eim St, Centerville, OH 45459",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 14,
      firstname: "Johnny",
      lastname: "Doelson",
      dob: "07/23/1978",
      phonenumber: "(555) 987-0003",
      streetaddress1: "303 Oak Ave, Fairview, TX 75069",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 15,
      firstname: "Johnnie",
      lastname: "Doerick",
      dob: "11/05/2000",
      phonenumber: "(555) 987-0004",
      streetaddress1: "404 Pine Ln, LakeWood, CO 80227",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 16,
      firstname: "John Paul",
      lastname: "Doevan",
      dob: "03/17/1969",
      phonenumber: "(555) 987-0005",
      streetaddress1: "505 Birch Blvd, Albany, NY 12207",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 99,
      firstname: "John David",
      lastname: "Doebrook",
      dob: "08/30/1995",
      phonenumber: "(555) 987-0006",
      streetaddress1: "606 Ceder Ct, Madison, WI 53703",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 88,
      firstname: "John Mark",
      lastname: "Doestone",
      dob: "02/14/1982",
      phonenumber: "(555) 987-0007",
      streetaddress1: "707 Walnut Dr, Raleigh, NC 27601",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 99,
      firstname: "John Lucas",
      lastname: "Doeland",
      dob: "10/09/1975",
      phonenumber: "(555) 987-0008",
      streetaddress1: "808 Chestnut St, Boise, ID 83702",
      streetaddress2: "Lorem Ipsum is simply ",
    },
    {
      id: 91,
      firstname: "John Michael",
      lastname: "Doeker",
      dob: "06/19/2003",
      phonenumber: "(555) 987-0009",
      streetaddress1: "909 Maple Way, Eugene, OR 97401",
      streetaddress2: "Lorem Ipsum is simply ",
    },
  ]);

  const [formData, setFormData] = useState({
    firstname: "",
    middlename: "",
    lastname: "",
    dob: "",
    gender: "",
    streetaddres1: "",
    streetaddres2: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    primaryPhone: "",
    secondaryPhone: "",
    email: "",
    primaryPrescriber: "",
    preferredlanguage: "",
    requiredTranslation: "",
    childsafetycaps: "",
    hippaAcknowledge: "",
    hippaAcknowledgeDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "phonenumber") {
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 3) {
        formattedValue = digits;
      } else if (digits.length <= 6) {
        formattedValue = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else {
        formattedValue = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )}-${digits.slice(6, 10)}`;
      }
    } else {
      formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
    }
    setData({ ...data, [name]: formattedValue });
  };

  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [name]: value,
    }));
  };

  const details = [
    {
      id: 1,
      name: "Doe John",
      order: "Active Orders: 01",
      dob: "01/08/1996 (28Years)",
      phoneNumber: "(555) 123-4567",
      address: "1234 Maple Rd, Anytown, USA",
      phoneNumber: "897778999",
    },
    {
      id: 2,
      name: "Doe John",
      order: "Active Orders: 01",
      dob: "01/08/1996 (28Years)",
      phoneNumber: "(555) 123-4567",
      address: "1234 Maple Rd, Anytown, USA",
      phoneNumber: "897778999",
    },
    {
      id: 3,
      name: "Doe John",
      order: "pending",
      dob: "01/08/1996 (28Years)",
      phoneNumber: "(555) 123-4567",
      address: "1234 Maple Rd, Anytown, USA",
      phoneNumber: "897778999",
    },
    {
      id: 3,
      name: "Doe John",
      order: "pending",
      dob: "01/08/1996 (28Years)",
      phoneNumber: "(555) 123-4567",
      address: "1234 Maple Rd, Anytown, USA",
      phoneNumber: "897778999",
    },
    {
      id: 4,
      name: "Doe John",
      order: "pending",
      dob: "01/08/1996 (28Years)",
      phoneNumber: "(555) 123-4567",
      address: "1234 Maple Rd, Anytown, USA",
      phoneNumber: "897778999",
    },
  ];

  const handleRowClick = (row) => {
    console.log(row, "rowS");
    navigate(`/workflow-patients-Patient-info/${row.id}`, { state: row });
  };

  const renderButton = (row) => {
    return (
      <div className="render-button-img">
        <div
          className="patient-details-tooltip statusIcon"
          onClick={() => setPatientEdit(!patientEdit)}
          id="ScheduleUpdateTooltip11"
        >
          <img src={editIcon} className="statusIcon" />

          <UncontrolledTooltip
            // className="tooltip-custom"
            // style={{ position: "relative", left: "30px", marginTop:"2px"}}
            placement="bottom"
            target="ScheduleUpdateTooltip11"
            trigger="hover"
          >
            Edit Details
          </UncontrolledTooltip>
        </div>
        {/* <img src={editIcon} onClick={() => setPatientEdit(true)} />{" "} */}
        <div
          className="patient-details-tooltip statusIcon"
          onClick={() => setOpenMedicationDetails(!openMedicationDetails)}
          id="ScheduleUpdateTooltip12"
        >
          <img src={dataRefreshIcon} className="statusIcon" />

          <UncontrolledTooltip
            // className="tooltip-custom"
            // style={{ position: "relative", left: "30px", marginTop:"2px"}}
            placement="bottom"
            target="ScheduleUpdateTooltip12"
            trigger="hover"
          >
            Transfer
          </UncontrolledTooltip>
        </div>

        <div
          className="patient-details-tooltip statusIcon"
          onClick={() => setOpenMedicationHistory(!openMedicationHistory)}
          id="ScheduleUpdateTooltip13"
        >
          <img src={dataSavaIcon} className="statusIcon" />

          <UncontrolledTooltip
            // className="tooltip-custom"
            // style={{ position: "relative", left: "30px", marginTop:"2px"}}
            placement="bottom"
            target="ScheduleUpdateTooltip13"
            trigger="hover"
          >
            Medication
          </UncontrolledTooltip>
        </div>
      </div>
    );
  };

  const columnData = [
    {
      id: 0,
      dataField: "options",
      text: "Options",
      show: true,
      width: 50,
      cellRenderer: (rowData) => renderButton(rowData),
    },
    {
      id: 11,
      dataField: "lastname",
      text: "Last Name",
      show: true,
      sort: true,
      width: 100,
    },
    {
      id: 14,
      dataField: "firstname",
      text: "First Name",
      show: true,
      sort: true,
      width: 100,
    },
    {
      id: 61,
      dataField: "dateofbirth",
      text: "Date of Birth",
      show: true,
      sort: true,
      width: 100,
    },
    {
      id: 78,
      dataField: "primaryphone",
      text: "Primary Phone",
      show: true,
      sort: true,
      width: 120,
    },
    {
      id: 980,
      dataField: "streetaddress1",
      text: "Address",
      show: true,
      sort: true,
      width: 200,
    },
    // {id:345,
    //   dataField: "streetaddress2",
    //   text: "Street Address Line-2",
    //   show: true,
    //   sort: true,
    //   width: 200,
    // },
  ];

  const date = new Date();
  const formattedDate = `${String(date.getDate()).padStart(2, 0)}/${String(
    date.getMonth() + 1
  ).padStart(2, 0)}/${date.getFullYear()}`;

  console.log(JSON.stringify(formattedDate));

  const rowData = addData.map((item) => ({
    // options: (
    //   <div>
    //     <img onClick={() => navigate("/patient-info")} src={editIcon} />{" "}
    //     <img src={dataRefreshIcon} /> <img src={dataSavaIcon} />
    //   </div>
    // ),
    id: item?.id,
    lastname: item.lastname || "-",
    firstname: item.firstname || "-",
    dateofbirth: item.dob || formattedDate,
    primaryphone: item.phonenumber || "-",
    streetaddress1: item.streetaddress1 || "1234 Maple Rd, Anytown, USA",
    streetaddress2: item.streetaddress2 || "lorem epsum",
  }));

  const patientsPerPage = 2; // Change this to adjust patients per page
  const pageSize = details.length;
  const totalPages = Math.ceil(details.length / patientsPerPage);
  const indexOfLastPatient = currentPage * patientsPerPage;
  const indexOfFirstPatient = indexOfLastPatient - patientsPerPage;
  const currentPatients = details.slice(
    indexOfFirstPatient,
    indexOfLastPatient
  );
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const togglePatientDetails = (index) => {
    setSelectedPatientIndex(selectedPatientIndex === index ? null : index);
  };

  const goBack = () => {
    // navigate(-1);
    setConfirm(true);
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };
  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleEndDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setEnddate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setEnddate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleEndDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setEnddate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleEndDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };
  // const handlesave = () => {
  //     handleSaveConfirmation();
  // }
  const onLeave = () => {
    handleSaveConfirmation();
  };
  const handleSaveConfirmation = () => {
    setConfirm(!confirm);
  };

  // const handleSubmit = (field) => {
  //   const newEntry = { id: Date.now(), value: data[field] };
  //   if (data.one !== "") {
  //     setTodosOne([...todosOne, newEntry]);
  //   }
  //   setData({ ...data, [field]: "" });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    setTodosOne([...todosOne, data]);
    setAddData((prev) => [data, ...prev]);
    bottomRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleDelete = (id, field) => {
    setTodosOne(todosOne.filter((item) => item.id !== id));
  };
  const onsubmit = () => {
    toast.success("E-Prescription has successfully approved");
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <>
      {!expandScreen ? (
        <>
          <div className="bg-white border-radius-4 p-3 rounded">
            <Container fluid className="d-flex gap-2 section-devider-border">
              <div className="heading-text pb-2">Search Patients</div>
            </Container>
            <Container fluid className="p-t-16">
              <Formik>
                <FormGroup className="mb-0">
                  <Row>
                    <Col className="pe-3">
                      <Label className="add-patient-heading">
                        <span className="required">*</span> Last Name
                      </Label>
                      <InputGroup>
                        <Input
                          id="lastname"
                          name="lastname"
                          type="text"
                          placeholder="Enter Last Name"
                          value={data.lastname}
                          onChange={handleChange}
                        ></Input>
                      </InputGroup>
                    </Col>
                    <Col className="pe-3">
                      <Label className="add-patient-heading">
                        <span className="required">*</span> First Name
                      </Label>
                      <InputGroup>
                        <Input
                          id="firstname"
                          name="firstname"
                          type="text"
                          placeholder="Enter First Name"
                          autoComplete="off"
                          value={data.firstname}
                          onChange={handleChange}
                        ></Input>
                      </InputGroup>
                    </Col>
                    <Col className="pe-3">
                      <Label className="add-patient-heading">
                        Phone Number
                      </Label>
                      <InputGroup>
                        <Input
                          id="phonenumber"
                          name="phonenumber"
                          type="text"
                          placeholder="Enter Phone Number"
                          autoComplete="off"
                          value={data.phonenumber}
                          onChange={handleChange}
                        ></Input>
                      </InputGroup>
                    </Col>
                    <Col className="required-date">
                      <Label className="add-patient-heading">
                        Date of Birth
                      </Label>
                      <FormGroup>
                        <InputGroup
                          onMouseLeave={handleMouseLeave}
                          className="date-14px"
                        >
                          <DatePicker
                            id="startDate"
                            name="dob"
                            selected={startDate}
                            onChange={(startDate) => handleStartDate(startDate)}
                            onFocus={() => handleFocus("StartDate")}
                            onBlur={handleBlur}
                            isClearable
                            onChangeRaw={handleStartDateRaw}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select Date of Birth"
                            autoComplete="off"
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                value={startDate}
                              />
                            }
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("startDate")}
                            onMouseEnter={() => setIsHover(!isHover)}
                            onMouseLeave={() => setIsHover(!isHover)}
                          >
                            <img
                              src={isHover ? Calendar : calenderBlackIcon}
                              alt=""
                              className="cursor-pointer"
                            />
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3} className="pe-3">
                      <Label className="add-patient-heading">City</Label>
                      <InputGroup>
                        <Input
                          id="city"
                          name="city"
                          type="text"
                          placeholder="Enter City"
                          autoComplete="off"
                          value={data.city}
                          onChange={handleChange}
                        ></Input>
                      </InputGroup>
                    </Col>
                    <Col sm={12} md={3} className="pe-3">
                      <Label className="add-patient-heading">State</Label>
                      <Select
                        className="dropdown-options"
                        options={[
                          { value: "newjercy", label: "New Jersey" },
                          { value: "illinois", label: "Illinois" },
                          { value: "pennsylvania", label: "Pennsylvania" },
                        ]}
                        placeholder="Select State"
                      />
                    </Col>
                    <Col md={3} className="pe-3">
                      <Label className="add-patient-heading">
                        Zip/Postal Code
                      </Label>
                      <InputGroup>
                        <Input
                          id="zipcode"
                          name="zipcode"
                          type="text"
                          placeholder="Enter Address"
                          autoComplete="off"
                          value={data.zipcode}
                          onChange={handleChange}
                        ></Input>
                      </InputGroup>
                    </Col>
                    <Col md={3}>
                      <Label className="add-patient-heading">Patient ID</Label>
                      <InputGroup>
                        <Input
                          id="patientid"
                          name="patientid"
                          type="text"
                          placeholder="Enter Patient ID"
                          autoComplete="off"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                  {!data.firstname || !data.lastname ? (
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        style={{
                          color: "#9E9E9E",
                          backgroundColor: "white",
                          borderColor: "#757575",
                        }}
                        color="tranparent"
                        onClick={() =>
                          setData({
                            lastname: "",
                            firstname: "",
                            phonenumber: "",
                            city: "",
                            state: "",
                            zipcode: "",
                          })
                        }
                      >
                        <img src={RefreshWhiteIcon} />
                        Reset
                      </Button>
                      <Button
                        color="tranparent"
                        style={{ backgroundColor: "#D3D3D3", color: "#757575" }}
                      >
                        <img src={searchInactiveIcon} />
                        Search
                      </Button>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        style={{ color: "#702C62" }}
                        color="secondary"
                        onClick={() =>
                          setData({
                            lastname: "",
                            firstname: "",
                            phonenumber: "",
                            city: "",
                            state: "",
                            zipcode: "",
                          })
                        }
                      >
                        <img src={RefreshPurpleIcon} />
                        Reset
                      </Button>
                      <Button color="primary" onClick={handleSubmit}>
                        <img src={searchWhiteIcon} />
                        Search
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </Formik>
            </Container>
          </div>
          <div style={{ borderBottom: "16px solid #f7f7f7" }}></div>
        </>
      ) : (
        <></>
      )}
      <div
        ref={bottomRef}
        className=" table-card scroll-table position-relative layout-alignment border-0 rounded bg-white"
      >
        <div className="d-flex justify-content-between align-items-center section-devider-border">
          <div>
            {" "}
            <div className="heading-text pb-2">
              {expandScreen ? (
                <img
                  src={leftArrow}
                  className="cursor-pointer left-arrow-btn"
                  onClick={() => setExpandScreen(false)}
                />
              ) : (
                ""
              )}{" "}
              Patients List (223)
            </div>
          </div>
          <div
            className="cursor-pointer"
            onClick={() => setExpandScreen(!expandScreen)}
          >
            <img src={expandScreen ? MinimizeIcon : ExpandIcon} />
          </div>
        </div>

        <Row className="p-t-16">
          {/* <Col>
            <Button className="clmn">
              <img src={filterIcon} />
              Filter{" "}
            </Button>
          </Col> */}
          <Col>
            <div className="d-flex justify-content-start align-items-center gap-2">
              <span className="f-16 font-weight-600">Filter</span>
              <ButtonGroup className="filter-btn-group">
                <Button
                  color="info"
                  outline
                  onClick={toggleFilter}
                  active={rSelected === "off"}
                >
                  OFF
                </Button>
                <Button
                  color="info"
                  outline
                  active={rSelected === "on"}
                  onClick={toggleFilter}
                >
                  ON
                </Button>
              </ButtonGroup>
            </div>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button color="secondary" className="back-button">
              <img src={exportIcon} /> Export
            </Button>
            <Button
              color="primary"
              onClick={() => setCreateNewPatient(!createNewPatient)}
            >
              <img src={plusIcon} alt="Icon" style={{ marginBottom: "2px" }} />
              <span style={{ color: "#FEFEFE" }}>Add New Patient</span>
            </Button>
          </Col>
        </Row>
        {/* <Button onClick={() => setOpenMedicationDetails(true)}>ad</Button> */}
        <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
          <ReactStrapTable
            data={rowData}
            columns={columnData}
            handleRowClick={handleRowClick}
            enablerowRouting={true}
          />
        </div>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={patientEdit}
          toggle={() => setPatientEdit(!patientEdit)}
        >
          <div className="casvas-header p-3 pb-2">
            <div>Edit Patient Details </div>
            <div
              className="cursor-pointer"
              onClick={() => setPatientEdit(!patientEdit)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup mb-3"></div>
          <OffcanvasBody className="p-4 pt-1 pb-0">
            <PatientEditInfo />
          </OffcanvasBody>
          <div className="basic-edit-footer">
            {/* <Button color="tranparent" style={{ color: "#9E9E9E" }}>
              <img
                src={
                  !data.firstname || !data.lastname
                    ? RefreshWhiteIcon
                    : RefreshPrupleIcon
                }
              />{" "}
              Reset
            </Button> */}
            <Button
              style={{ color: "#702C62" }}
              color="secondary"
              onClick={() =>
                setFormData({
                  lastname: "",
                  firstname: "",
                  gender: "",
                  dob: "",
                })
              }
            >
              <img src={RefreshPurpleIcon} />
              Reset
            </Button>
            <Button color="primary">
              <img src={saveWhiteIcon} />
              Save
            </Button>
          </div>
        </Offcanvas>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={openMedicationDetails}
          toggle={() => setOpenMedicationDetails(!openMedicationDetails)}
        >
          <div className="casvas-header">
            <div>Transfer </div>
            <div
              className="cursor-pointer"
              onClick={() => setOpenMedicationDetails(!openMedicationDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div
            className="section-devider-border"
            style={{
              margin: "0px 12px 15px 18px",
            }}
          ></div>
          <OffcanvasBody>
            <MedicationEditDetails />
          </OffcanvasBody>
        </Offcanvas>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={createNewPatient}
          toggle={() => setCreateNewPatient(!createNewPatient)}
        >
          <div className="casvas-header p-3 pb-2">
            <div>Add New Patient </div>
            <div
              className="cursor-pointer"
              onClick={() => setCreateNewPatient(!createNewPatient)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup mb-3"></div>
          <OffcanvasBody
            className="p-4 pt-1 pb-0"
            style={{ scrollbarWidth: "thin" }}
          >
            <AddNewPatientDetails
              data={formData}
              setData={setFormData}
              focusedInput={dob}
              setFocusedInput={setDob}
            />
          </OffcanvasBody>
          <div className="basic-edit-footer">
            {dob == "" ||
            formData.lastname == "" ||
            formData.firstname == "" ||
            formData.gender == "" ? (
              <Button color="tranparent" style={{ color: "#9E9E9E" }}>
                <img
                  src={
                    !data.firstname || !data.lastname
                      ? RefreshWhiteIcon
                      : RefreshPrupleIcon
                  }
                />{" "}
                Reset
              </Button>
            ) : (
              <Button
                style={{ color: "#702C62" }}
                color="secondary"
                onClick={() =>
                  setFormData({
                    lastname: "",
                    firstname: "",
                    gender: "",
                    dob: "",
                  })
                }
              >
                <img src={RefreshPurpleIcon} />
                Reset
              </Button>
            )}

            {dob == "" ||
            formData.lastname == "" ||
            formData.firstname == "" ||
            formData.gender == "" ? (
              <Button
                disabled
                color="tranparent"
                style={{
                  backgroundColor: "#D3D3D3",
                  color: "#757575",
                  border: "none",
                }}
              >
                <img src={saveDisableIcon} />
                Save
              </Button>
            ) : (
              <Button color="primary">
                <img src={saveWhiteIcon} />
                Save
              </Button>
            )}
          </div>
        </Offcanvas>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={openMedicationHistory}
          toggle={() => setOpenMedicationHistory(!openMedicationHistory)}
        >
          <div className="casvas-header">
            <div>Medication History </div>
            <div className="d-flex justify-content-center align-items-center gap-4">
              <div
                className="d-flex justify-content-end"
                style={{ fontSize: "16px" }}
              >
                <div onClick={undefined} className="">
                  {/* {openStatus ? (
                  <img src={purpleCrossIcon} alt="icon" />
                ) : ( */}
                  <img src={statusPurple} alt="icon" />
                  {/* )}{" "} */}
                  <span style={{ marginLeft: "8px" }}>Order Status</span>
                </div>
              </div>
              <div
                className="cursor-pointer"
                onClick={() => setOpenMedicationHistory(!openMedicationHistory)}
              >
                <img src={CloseIcon} />
              </div>
            </div>
          </div>
          <div
            className="section-devider-border"
            style={{
              margin: "0px 12px 15px 18px",
            }}
          ></div>
          <OffcanvasBody>
            <MedicationHistory />
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </>
  );
};
export default PatientsPage;
